export const PARTBNB_GLOBAL = {
  SESSION_TIME: 60000
};
